// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "./static/js/" + chunkId + ".1740973983770.js?v=1740973983770";
};